import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import FormatQuoteOutlinedIcon from '@mui/icons-material/FormatQuoteOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';

import { CHAR_LIMIT, textFieldSx } from '../OpenDoor/constants';

export { CHAR_LIMIT, textFieldSx };

/** Session-only Handle a Reply inputs (not stored on Prospect). */
export const LATEST_REPLY_CHAR_LIMIT = 10000;
export const COMMUNICATION_HISTORY_CHAR_LIMIT = 50000;

export const FIELD_CHAR_LIMITS = {
  fullName: CHAR_LIMIT,
  company: CHAR_LIMIT,
  title: CHAR_LIMIT,
  linkedin: CHAR_LIMIT,
  howDoYouKnowThisPerson: CHAR_LIMIT,
  whyClientRelevant: CHAR_LIMIT,
  anythingElse: CHAR_LIMIT,
  latestProspectReply: LATEST_REPLY_CHAR_LIMIT,
  communicationHistory: COMMUNICATION_HISTORY_CHAR_LIMIT,
};

export const RESEARCH_SECTIONS = [
  { id: 'company', title: 'Company overview', sourceCount: 5, icon: BusinessOutlinedIcon },
  { id: 'decision', title: 'Decision makers', sourceCount: 3, icon: GroupsOutlinedIcon },
  { id: 'why-now', title: 'Why now?', sourceCount: 4, icon: ScheduleOutlinedIcon },
  { id: 'quotes', title: 'Relevant quotes', sourceCount: 4, icon: FormatQuoteOutlinedIcon },
  { id: 'business', title: 'Business model & revenue streams', sourceCount: 4, icon: AccountTreeOutlinedIcon },
  { id: 'customers', title: 'Similar customers', sourceCount: 3, icon: HandshakeOutlinedIcon },
  { id: 'sources', title: 'All sources', sourceCount: 12, icon: SourceOutlinedIcon },
];

export const REFINE_CHIPS = [
  'Make it shorter',
  'Answer more directly',
  'Less formal',
  'Stronger CTA',
  'Softer tone',
  'More specific',
];

export const INITIAL_CONTACT_FORM = {
  fullName: '',
  company: '',
  title: '',
  linkedin: '',
  howDoYouKnowThisPerson: '',
  whyClientRelevant: '',
  anythingElse: '',
  latestProspectReply: '',
  communicationHistory: '',
};

export const buildMockSuggestedReply = ({ fullName, company, companyName }) => {
  const firstName = (fullName || 'there').trim().split(/\s+/)[0] || 'there';
  const prospectCompany = company || 'your company';
  const client = companyName || 'our product';

  return {
    label: 'Suggested reply',
    body: `Hi ${firstName},\n\nThanks for getting back to me — that makes sense.\n\nBased on what you shared and where ${prospectCompany} is focused right now, I think a short conversation with ${client} could be useful. Happy to keep it lightweight and answer your questions directly.\n\nWould you be open to a 15-minute call this week or next?\n\nBest,\nAlice`,
    whyThisReply: `The reply answers ${firstName}'s message directly, keeps the tone concise based on your relationship context, and follows the client's GTM Doctrine by steering toward a short call rather than sending additional material.`,
  };
};
